<div [style.height]="height"
     class="flex flex-col gap-4 p-4 border border-gray-200 rounded-lg bg-white animate-pulse">
  <!-- Header skeleton -->
  <div class="flex flex-row items-center gap-2">
    <div class="h-4 bg-gray-200 rounded-full flex-1 max-w-[60%]"></div>
    <div class="h-5 w-14 bg-gray-200 rounded-full"></div>
  </div>

  <!-- Description skeleton -->
  <div class="flex flex-col gap-2 flex-1">
    <div class="h-3 bg-gray-200 rounded-full w-full"></div>
    <div class="h-3 bg-gray-200 rounded-full w-[80%]"></div>
  </div>

  <!-- Action buttons skeleton -->
  <div class="flex flex-row gap-4">
    <div class="h-9 bg-gray-200 rounded-lg flex-1"></div>
    <div class="h-9 bg-gray-200 rounded-lg flex-1"></div>
  </div>
</div>
